<div>
  <section class="weekly-report-section daily-dashboard-heading">
    <p class="qundis-ubuntu-32">Stillstandsmeldungen der letzten 7 Tage für Produktionslinie {{
        userService.userProductionLineName()
      }}
    </p>
    <p class="qundis-ubuntu-14">Aktueller Zeitraum: {{ startDate() | date:'EEEEEE dd.MM.yyyy' }}
      bis einschließlich {{ endDate() | date:'EEEE dd.MM.yyyy' }}</p>
  </section>
  <section class="weekly-report-section diagram-section d-flex flex-row align-items-center justify-content-around">
    <div class="pie-chart">
      <app-pie-chart [chartData]="chartData()"></app-pie-chart>
    </div>
    <div class="statistics d-flex flex-row flex-wrap gap-3 ps-5">
      <app-report-card class="chart-detail-item d-flex" [heading]="'Gesamtzeit'">
        <div class="d-flex justify-content-center align-items-center">
          <p class="detail-item-value py-3 text-qundis-primary qundis-page-heading-h1">168 h</p>
        </div>
      </app-report-card>
      <app-report-card class="chart-detail-item d-flex" [heading]="'Betriebszeit'">
        <div class="d-flex justify-content-center align-items-center">
          <p
            class="detail-item-value py-3 text-qundis-active-dark qundis-page-heading-h1">
            {{ Math.round(chartData().datasets[0].data[1]) }} h /
            {{ Math.round(chartData().datasets[0].data[1] / 168 * 100) }} %</p>
        </div>
      </app-report-card>
      <app-report-card class="chart-detail-item d-flex" [heading]="'Ausfallzeit'">
        <div class="d-flex justify-content-center align-items-center">
          <p
            class="detail-item-value py-3 text-qundis-warn qundis-page-heading-h1">{{
              Math.round(chartData().datasets[0].data[0])
            }} h /
            {{ Math.round(chartData().datasets[0].data[0] / 168 * 100) }} %</p>
        </div>
      </app-report-card>
      <app-report-card class="chart-detail-item d-flex" [heading]="'gelöste Stillstände'">
        <div class="d-flex justify-content-center align-items-center">
          <p
            class="detail-item-value py-3 text-qundis-primary qundis-page-heading-h1">{{ reportDashboardService.vmWeekly().solvedReports.length }}</p>
        </div>
      </app-report-card>
      <app-report-card class="chart-detail-item d-flex" [heading]="'aktive Stillstände'">
        <div class="d-flex justify-content-center align-items-center">
          <p class="detail-item-value py-3 text-qundis-warn qundis-page-heading-h1">{{
              reportDashboardService.vmWeekly().activeReports.length
            }}</p>
        </div>
      </app-report-card>
    </div>
  </section>
  <section class="weekly-report-section dashboard-data" *ngFor="let item of dashboardItems()">
    <app-report-card [heading]="item.heading">
      <div>
        <app-report-table
          [tableWidth]="'w-100'"
          [dataSource]="item.dataSource"
          [displayAll]="true"
          [tableHeading]="item.tableHeading"
          [tableHeadingClass]="item.tableHeadingClass"
          [displayedColumns]="item.displayedColumns"
          [columnWidths]="item.columnWidths"
        ></app-report-table>
      </div>
    </app-report-card>
  </section>
</div>
